import { makeStyles } from "tss-react/mui";

export default makeStyles({ name: "NIISensitivityModelerGlobal" })(
  (_theme, toCompare) => ({
    page: {
      margin: "20px",
    },
    NIISensitivityModelerGlobalCardResponsive: {
      width: toCompare ? "48%" : "100%",
      [`@media (max-width:1060px)`]: {
        width: "100%",
      },
    },
    nIISensitivityModelerGlobalExportBtn: {
      display: "flex",
      justifyContent: "flex-end",
      marginRight: "10px",
      marginTop: "-30px",
    },
    SaveBtn: {
      display: "flex",
      justifyContent: "flex-end",
      marginRight: "10px",
      marginTop: "10px",
    },
  }),
);
